import { AssistantField } from '@kizenapps/engine';

export const InvalidBlock = ({ field }: { field: AssistantField }) => {
  return (
    <div>
      <code>Invalid field: {JSON.stringify(field, null, 2)}</code>
    </div>
  );
};
